require('./mortgageRequestPreApproval.scss');

//@vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const { isEqual } = require('lodash/lang');

//@core
const { formatText, FormattedText } = require('core/i18n').i18n;

//@commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const WizardError = require('components/commons/wizardError/wizardError');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const MortgageRequestPreApprovalStepOne = require('components/mortgageRequest/mortgageRequestPreApproval/mortgageRequestPreApprovalStepOne/mortgageRequestPreApprovalStepOne');
const MortgageRequestPreApprovalStepTwo = require('components/mortgageRequest/mortgageRequestPreApproval/mortgageRequestPreApprovalStepTwo/mortgageRequestPreApprovalStepTwo');
const MortgageRequestPreApprovalStepThree = require('components/mortgageRequest/mortgageRequestPreApproval/mortgageRequestPreApprovalStepThree/mortgageRequestPreApprovalStepThree');
const MortgageRequestPreApprovalStepFourth = require('components/mortgageRequest/mortgageRequestPreApproval/mortgageRequestPreApprovalStepFourth/mortgageRequestPreApprovalStepFourth');
const MortgageRequestCounterOffer = require('components/mortgageRequest/mortgageRequestPreApproval/mortgageRequestCounterOffer/mortgageRequestCounterOffer');

// @constants
const { FIRST_STEP, FIFTH_STEP } = require('constants/index');
const mortgageRequestStates = require('constants/mortgageRequestStates');
const VALID_STATE_RESTORE_PRE_APPROVAL = [
    mortgageRequestStates.PRE_APROBACION,
    mortgageRequestStates.PRE_APROBADO,
    mortgageRequestStates.TASA_ESF_KO
];
const INVALID_MORTGAGES_STATES = [
    mortgageRequestStates.SIMULACION,
    mortgageRequestStates.PRE_APROBACION,
    mortgageRequestStates.PRE_APROBADO,
    mortgageRequestStates.TASA_ESF_KO,
    mortgageRequestStates.ANULADO,
    mortgageRequestStates.FIRMADO,
    mortgageRequestStates.UNKNOWN,
    mortgageRequestStates.SIN_EXPEDIENTE
];
const { ACTION_EVENT_VIEW } = require('constants/tagging');
const { PROC_START } = require('utilities/tagging');

class MortgageRequestPreApproval extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showPreLeaveModal: false, isMortgagesRequestInitialStep: true };
        this.onCancel = this.onCancel.bind(this);
        this.handleConfirmLeave = this.handleConfirmLeave.bind(this);
        this.onFinish = this.onFinish.bind(this);
        this.redirect = this.redirect.bind(this);
        this.handleSetVisibleStep = this.handleSetVisibleStep.bind(this);
    }

    componentDidMount() {
        const { immMortgageRequestState, restoreProcess } = this.props;
        const expedientState = immMortgageRequestState.get('estado');

        if (!!expedientState && VALID_STATE_RESTORE_PRE_APPROVAL.indexOf(expedientState) !== -1) {
            restoreProcess();
        }
    }
    onCancel() {
        this.setState({
            showPreLeaveModal: true
        }, this.redirect);
    }
    handleConfirmLeave() {
        const { resetState } = this.props;
        resetState();
    }
    redirect() {
        this.props.history.push('/myprofile/loans-mortgages');
    }
    onFinish() {
        const { linkMortgage, history } = this.props;
        this.setState({
            showPreLeaveModal: false
        }, () => {
            linkMortgage(history);
        });
    }
    handleSetVisibleStep(step) {
        const { setVisibleStep } = this.props;
        setVisibleStep(step);
        this.setState({ isMortgagesRequestInitialStep: false });
    }
    validatePreApprovalMortgagesInitialStep() {
        const { immMortgageRequestState } = this.props;
        const expedientState = immMortgageRequestState.get('estado');
        return (!!expedientState
            && !(INVALID_MORTGAGES_STATES.indexOf(expedientState) === -1)
            && !(VALID_STATE_RESTORE_PRE_APPROVAL.indexOf(expedientState) !== -1))
    }
    buildStepOne() {
        const {
            communityList,
            flagBasedFeatures,
            formHandlers,
            immCollectives,
            immGlobalVariables,
            immMortgageRequest,
            setMaxHousingCost,
        } = this.props;
        return (
            <MortgageRequestPreApprovalStepOne
                immMortgageRequest={immMortgageRequest}
                immFlagBasedFeatures={flagBasedFeatures}
                immGlobalVariables={immGlobalVariables}
                immCollectives={immCollectives}
                formHandlers={formHandlers}
                communityList={communityList}
                setMaxHousingCost={setMaxHousingCost}
            />
        );
    }
    buildStepTwo() {
        const { immMortgageRequest, immCollectives, immGlobalVariables, validateStep, preApprovalLoadAFI, preApprovalLoadAFIFinish, preApprovalUUID, flagBasedFeatures, getInsurancesDataAfi, mortgageHomeInsurance, productTypeInf, formHandlers } = this.props;
        return (
            <MortgageRequestPreApprovalStepTwo
                immMortgageRequest={immMortgageRequest}
                flagBasedFeatures={flagBasedFeatures}
                immGlobalVariables={immGlobalVariables}
                validateStep={validateStep}
                preApprovalLoadAFI={preApprovalLoadAFI}
                preApprovalLoadAFIFinish={preApprovalLoadAFIFinish}
                immCollectives={immCollectives}
                preApprovalUUID={preApprovalUUID}
                getInsurancesDataAfi={getInsurancesDataAfi}
                mortgageHomeInsurance={mortgageHomeInsurance}
                onHandleGetCatalogInformation={formHandlers.handleGetCatalogInformation}
                productTypeInf={productTypeInf} />
        );
    }
    buildStepThree() {
        const {
            formHandlers,
            taxesInformationRequest,
            immTaxesInformation,
            immMortgageRequest,
            immProfile,
            savePartialProcess,
            isClientWithoutAccounts,
            discardTemporalChangesInCurrentModal,
            clearTemporalChangesInCurrentModal,
            immCollectives,
            requestConditions,
            mortgageConditions,
            immScreen
        } = this.props;
        const screenWidthResponsive = window.innerWidth < '992';

        return (
            <MortgageRequestPreApprovalStepThree
                immMortgageRequest={immMortgageRequest}
                immProfile={immProfile}
                isClientWithoutAccounts={isClientWithoutAccounts}
                formHandlers={formHandlers}
                taxesInformationRequest={taxesInformationRequest}
                immTaxesInformation={immTaxesInformation}
                savePartialProcess={savePartialProcess}
                discardTemporalChangesInCurrentModal={discardTemporalChangesInCurrentModal}
                clearTemporalChangesInCurrentModal={clearTemporalChangesInCurrentModal}
                immCollectives={immCollectives}
                mortgageConditions={mortgageConditions}
                requestConditions={requestConditions}
                responsiveMobileVersion={screenWidthResponsive}

            />
        );
    }
    buildStepFourth() {
        const { immMortgageRequest, immTaxesInformation, immGlobalVariables, immCollectives, requestConditions, mortgageConditions } = this.props;
        return (
            <MortgageRequestPreApprovalStepFourth
                immMortgageRequest={immMortgageRequest}
                immCollectives={immCollectives}
                immGlobalVariables={immGlobalVariables}
                immTaxesInformation={immTaxesInformation}
                mortgageConditions={mortgageConditions}
                requestConditions={requestConditions}
            />);
    }
    buildWizardActions() {
        const { validateStep } = this.props;
        return {
            setWillCancel: this.onCancel,
            cancel: this.onCancel,
            finish: this.onFinish,
            setVisibleStep: this.handleSetVisibleStep,
            validateStep,
            setWillGoBack: () => false,
            resetStep: () => false
        };
    }
    buildWizard() {
        const { immMortgageRequest, immMortgageRequestSimulationLinkClient, immScreen } = this.props;
        const { showPreLeaveModal, isMortgagesRequestInitialStep } = this.state;
        const showLoading = immMortgageRequest.get('showLoading');
        const isFetching = immMortgageRequest.get('isFetching');
        const isSaving = immMortgageRequestSimulationLinkClient.get('isFetching');
        const immSteps = immMortgageRequest.get('steps');
        const visibleStep = immMortgageRequest.get('visibleStep');
        const stepsAmount = immSteps.size;
        const stepOne = isFetching ? <LoadingSection /> : this.buildStepOne();
        const stepTwo = this.buildStepTwo();
        const stepThree = isSaving && showLoading ? <LoadingSection /> : this.buildStepThree();
        const stepFourth = this.buildStepFourth();
        const actions = this.buildWizardActions();
        const idPreaprob = immMortgageRequest.get('idPreaprob');
        const mortgagesRequestFirstStep = {
            categoriaEvento: 'proc-hipotecario-pre-aprobacion',
            accionEvento: PROC_START,
            etiquetaEvento: ACTION_EVENT_VIEW
        };
        const tealiumIdPreaprob = !!idPreaprob && visibleStep === FIFTH_STEP
            ? { idPreaprob: idPreaprob }
            : visibleStep === 1 && isMortgagesRequestInitialStep && this.validatePreApprovalMortgagesInitialStep()
                ? mortgagesRequestFirstStep
                : null;
        const nextStepOne = <FormattedText value="mortgageRequestPreApproval-calculate" />;
        const nextStepTree = <FormattedText value="mortgageRequestPreApproval-preApprove" />;
        const validWhereHousing = isEqual(immMortgageRequest.get('whereHousing'), 0);
        const disabledCalculateButton = validWhereHousing || !immMortgageRequest.getIn(['steps', FIRST_STEP, 'valid']);
        const continueButtonText = 'mortgageRequestPreApprovalStepFourth-mortgageRequestPreApprovalStepFourth_continue';
        const cancelButtonText = formatText('mortgageRequestPreApproval-abandon');
        const commonsBack = formatText('common-back');
        const screenWidthResponsive = window.innerWidth < '992';
        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                wizardClass="mortgage-request-pre-approval__wizard"
                isFetching={isFetching || isSaving}
                showPreLeaveModal={showPreLeaveModal}
                onConfirmLeave={this.handleConfirmLeave}
                tealium={tealiumIdPreaprob}
                isTaggingSecondVersion
                responsiveMobileVersion={screenWidthResponsive}
                finalTitle={this.props.finalTitle}
            >
                <WizardStep
                    position="first"
                    cancelButton
                    cancelButtonText={commonsBack}
                    nextButtonCustomText={nextStepOne}
                    nextButtonDisabled={disabledCalculateButton}
                    responsiveMobileVersion={screenWidthResponsive}

                >
                    {stepOne}
                </WizardStep>
                <WizardStep
                    position="middle"
                    nextButtonDisabled
                    cancelButtonText={commonsBack}
                    cancelButton
                    isFetching={isFetching}
                    responsiveMobileVersion={screenWidthResponsive}

                >
                    {stepTwo}
                </WizardStep>
                <WizardStep
                    position="middle"
                    nextButtonCustomText={nextStepTree}
                    cancelButtonText={cancelButtonText}
                    cancelButton
                    isLoading={isFetching || isSaving}
                >
                    {stepThree}
                </WizardStep>
                <WizardStep
                    position="last"
                    finishButton
                    isLoading={isFetching}
                    immFinalButton={continueButtonText}
                    cancelButton
                    cancelButtonText={cancelButtonText}
                    ccDefaultBehaviour
                >
                    {stepFourth}
                </WizardStep>
            </Wizard>
        );
    }

    buildWizardError() {
        const errorWizardKOTitle = formatText('mortgageRequestPreApproval-errorWizardKOTitle');
        const errorWizardKOFirstParagraph = formatText('mortgageRequestPreApproval-errorWizardKOFirstParagraph');
        const errorWizardKOSecondParagraph = formatText('mortgageRequestPreApproval-errorWizardKOSecondParagraph');
        const errorWizardKOButton = formatText('mortgageRequestPreApproval-errorWizardKOButton');
        const koButton = { label: errorWizardKOButton };

        return (
            <WizardError
                errorMessage={errorWizardKOTitle}
                mainButton={koButton}
                customClassName="mortgage-request-pre-approval__error-message"
                onMainButtonClick={this.props.handleKoReturnWizard}
                icon="error"
            >
                <p className="mortgage-request-pre-approval__error-message--paragraph">
                    {errorWizardKOFirstParagraph}
                </p>
                <p className="mortgage-request-pre-approval__error-message--paragraph">
                    {errorWizardKOSecondParagraph}
                </p>
            </WizardError>
        );
    }

    buildCounterOffer() {
        const {
            toggleCounterOfferView,
            validateStep,
            immMortgageRequest,
            acceptPreApprovalCounterOffer,
            preApprovalRequest
        } = this.props;

        return (
            <MortgageRequestCounterOffer
                toggleCounterOfferView={toggleCounterOfferView}
                validateStep={validateStep}
                immMortgageRequest={immMortgageRequest}
                acceptPreApprovalCounterOffer={acceptPreApprovalCounterOffer}
                preApprovalRequest={preApprovalRequest}
            />
        )
    }

    render() {
        const { immMortgageRequest } = this.props;
        const wizardHasError = immMortgageRequest.get('error');
        const showCounterOfferView = immMortgageRequest.get('showCounterOfferView');

        let content;

        if (wizardHasError) {
            content = this.buildWizardError();
        } else if (showCounterOfferView) {
            content = this.buildCounterOffer();
        } else {
            content = this.buildWizard();
        }

        return content;
    }
}
MortgageRequestPreApproval.propTypes = {
    history: PropTypes.object.isRequired,
    immMortgageRequest: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    isClientWithoutAccounts: PropTypes.bool.isRequired,
    immMortgageRequestState: PropTypes.object.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    handleKoReturnWizard: PropTypes.func.isRequired,
    formHandlers: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    communityList: PropTypes.array.isRequired,
    linkMortgage: PropTypes.func.isRequired,
    preApprovalLoadAFI: PropTypes.func.isRequired,
    preApprovalLoadAFIFinish: PropTypes.func.isRequired,
    preApprovalUUID: PropTypes.func.isRequired,
    getInsurancesDataAfi: PropTypes.func.isRequired,
    mortgageHomeInsurance: PropTypes.func.isRequired,
    productTypeInf: PropTypes.func.isRequired,
    toggleCounterOfferView: PropTypes.func.isRequired,
    acceptPreApprovalCounterOffer: PropTypes.func.isRequired,
    resetState: PropTypes.func.isRequired,
    preApprovalRequest: PropTypes.func.isRequired,
    taxesInformationRequest: PropTypes.func.isRequired,
    immTaxesInformation: PropTypes.object.isRequired,
    savePartialProcess: PropTypes.func.isRequired,
    restoreProcess: PropTypes.func.isRequired,
    immMortgageRequestSimulationLinkClient: PropTypes.object,
    discardTemporalChangesInCurrentModal: PropTypes.func,
    clearTemporalChangesInCurrentModal: PropTypes.func,
    immCollectives: PropTypes.object,
    setMaxHousingCost: PropTypes.func.isRequired,
    mortgageConditions: PropTypes.object,
    requestConditions: PropTypes.func.isRequired,
};
module.exports = withRouter(MortgageRequestPreApproval);
